import FormCollection from './FormCollection'

export default FormCollection



// WEBPACK FOOTER //
// ./src/components/Form/Collection/index.js